<template>
  <notLoginLayout class="reset-password">
    <b-form>
      <b-form-group
        label="新密碼"
        label-for="reset-new-password"
        class="required-icon-star"
      >
        <b-form-input
          id="reset-new-password"
          :value="$store.getters.verifyAccount.password"
          @input="$store.commit('verifyAccountNewPassword', $event)"
          :state="verifyNewPassword"
          :title="'輸入格式有誤'"
          type="password"
          required
          placeholder="密碼長度需大於或等於 8"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label="確認新密碼"
        label-for="reset-confirm-password"
        class="required-icon-star"
      >
        <b-form-input
          id="reset-confirm-password"
          :value="$store.getters.verifyAccount.password_confirmation"
          @input="$store.commit('verifyAccountNewPasswordConfirmation', $event)"
          :state="verifyConfirmPassword"
          :title="'輸入格式有誤'"
          type="password"
          required
          placeholder="密碼長度需大於或等於 8"
        ></b-form-input>
      </b-form-group>
    </b-form>
    <div class="text-right">
      <b-button @click="verifyForm" class="mr-3" type="submit" variant="primary"
        >修改</b-button
      >
      <b-button
        @click="$router.push({ name: 'login' })"
        type="submit"
        variant="dark"
        >取消</b-button
      >
    </div>
  </notLoginLayout>
</template>

<script>
import notLoginLayout from "@/layout/NotLoginLayout.vue";
import mixinsVerify from "@/utility/mixinsVerify.js";
export default {
  components: {
    notLoginLayout
  },
  mixins: [mixinsVerify],
  methods: {
    verifyForm() {
      this.verifyNewPassword =
        this.hasValue(this.$store.getters.verifyAccount.password) === null
          ? this.passwordRegexp(this.$store.getters.verifyAccount.password)
          : false;
      this.verifyConfirmPassword =
        this.hasValue(
          this.$store.getters.verifyAccount.password_confirmation
        ) === null
          ? this.passwordRegexp(
              this.$store.getters.verifyAccount.password_confirmation
            )
          : false;
      if (
        this.verifyNewPassword === false ||
        this.verifyConfirmPassword === false
      ) {
        return;
      } else if (
        this.isSameInPassword(
          this.$store.getters.verifyAccount.password,
          this.$store.getters.verifyAccount.password_confirmation
        ) === false
      ) {
        this.verifyConfirmPassword = false;
        alert("請檢查「確認新密碼」欄位，與「新密碼」欄位不相同");
      } else this.onSubmit();
    },
    onSubmit() {
      this.$store
        .dispatch("resetPassword")
        .then(() => {
          this.$router.push({ name: "login" });
        })
        .catch(e => {
          console.warn(">>>> resetPassword error", e);
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
